export default __webpack_public_path__ + "static/media/SCISLogo.dba96950.svg";